import { css } from 'styled-components';

export const linkStyles = css`
  border-bottom: 1px solid ${(props) => props.theme.main.colors.clay3};
  font-weight: 500;
  cursor: pointer;
`;
